import { ProgressInfo } from '@descomplica/dex-models';

export interface ProgressState {
  progresses: { [key: string]: ProgressInfo };
  isLoadingBaseProgress: boolean;
  firstContentConsumedDate: Date | null;
}

const state: ProgressState = {
  progresses: {},
  isLoadingBaseProgress: true,
  firstContentConsumedDate: null,
};

export default state;
